import { actions } from '../constants/postcode_light_box/actions';
import Dispatcher from '../dispatcher';

function show() {
    Dispatcher.handlePostcodeLightBoxAction({
        type: actions.SHOW
    });
}

function hide() {
    Dispatcher.handlePostcodeLightBoxAction({
        type: actions.HIDE
    });
}

function showError() {
    Dispatcher.handlePostcodeLightBoxAction({
        type: actions.SHOW_ERROR
    });
}

function hideError() {
    Dispatcher.handlePostcodeLightBoxAction({
        type: actions.HIDE_ERROR
    });
}

export {
    show,
    hide,
    showError,
    hideError
};
